import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { Actividad } from './actividades.model';

@Injectable({
  providedIn: 'root'
})
export class ActividadesService {
  url: string;
  token: string;
  endpoint = 'actividades';

  constructor(private http: HttpClient) { }

  getActividades(): Observable<Actividad[]> {
    return this.http.get<Actividad[]>(`${this.url}/${this.endpoint}/`, {
      params: { token: this.token }
    });
  }

  addActividad(actividad: Actividad): Observable<Actividad> {
    return this.http.post<Actividad>(`${this.url}/${this.endpoint}/`, {
      ...actividad
    });
  }

  addActividades(actividades: Actividad[]): Observable<Actividad[]> {
    return this.http.post<Actividad[]>(`${this.url}/${this.endpoint}/`, {
      ...actividades
    });
  }

  changeActividad(p: Actividad): Observable<Actividad> {
    return this.http.patch<Actividad>(`${this.url}/${this.endpoint}/${p.id}`, {
      actividad: p,
      token: this.token
    });
  }

  deleteActividad(p: Actividad): Observable<Actividad> {
    return this.http.delete<Actividad>(`${this.url}/${this.endpoint}/${p.id}`, {
      params: { token: this.token }
    });
  }


}
